module.exports = __webpack_public_path__ + "prod/1.42.2/img/solution8.6d01fc78.png";